<template>
    <div class="page_hx_core flex-col">
        <div class="group_10 flex-row">
            <div class="section_9 flex-col">
                <span class="text_27">协助应对企业面临的普遍问题</span>
                <span class="text_28">SOLVE&nbsp;THE&nbsp;CORE&nbsp;PAIN&nbsp;POINTS</span>
                <div class="list_10">
                    <div
                            class="list-items_1 flex-col"
                            v-for="(item, index) in loopData1"
                            :key="item.id"
                            @click="toggleActive(index, 1)"
                            @mouseenter="handleMouseEnter(index, 1)"
                            @mouseleave="handleMouseLeave(index, 1)"
                    >
                        <img
                                v-if="item.slot1 === 1 && !activeStates1[index]"
                                class="image_10"
                                referrerpolicy="no-referrer"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <img
                                v-if="item.slot2 === 2 && !activeStates1[index]"
                                class="label_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_solve_icon_01.png"
                        />
                        <span class="text_29" v-html="item.lanhutext0" v-show="!activeStates1[index]"></span>

                        <div
                                class="hover-mask"
                                :class="{ 'active': activeStates1[index] }"
                                @click.stop="toggleActive(index, 1)"
                        >
                            <div class="hover-content">
                                <div class="problem-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_problem_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.problem.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.problem.value }}</span>
                                    </div>
                                </div>
                                <div class="solution-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper  flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_solve_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.solve.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.solve.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list_10">
                    <div
                            class="list-items_1 flex-col"
                            v-for="(item, index) in loopData2"
                            :key="item.id"
                            @click="toggleActive(index, 2)"
                            @mouseenter="handleMouseEnter(index, 2)"
                            @mouseleave="handleMouseLeave(index, 2)"
                    >
                        <img
                                v-if="item.slot1 === 1 && !activeStates2[index]"
                                class="image_10"
                                referrerpolicy="no-referrer"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <img
                                v-if="item.slot2 === 2 && !activeStates2[index]"
                                class="label_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_solve_icon_01.png"
                        />
                        <span class="text_29" v-html="item.lanhutext0" v-show="!activeStates2[index]"></span>

                        <div
                                class="hover-mask"
                                :class="{ 'active': activeStates2[index] }"
                                @click.stop="toggleActive(index, 2)"
                        >
                            <div class="hover-content">
                                <div class="problem-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_problem_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.problem.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.problem.value }}</span>
                                    </div>
                                </div>
                                <div class="solution-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper  flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_solve_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.solve.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.solve.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list_10_one">
                    <div
                            class="list-items_1 flex-col"
                            v-for="(item, index) in loopData3"
                            :key="item.id"
                            :class="{ 'hidden-item': !item.show }"
                            @click="toggleActive(index, 3)"
                            @mouseenter="handleMouseEnter(index, 3)"
                            @mouseleave="handleMouseLeave(index, 3)"
                    >
                        <img
                                v-if="item.slot1 === 1 && !activeStates3[index]"
                                class="image_10"
                                referrerpolicy="no-referrer"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <img
                                v-if="item.slot2 === 2 && !activeStates3[index]"
                                class="label_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_solve_icon_01.png"
                        />
                        <span class="text_29" v-html="item.lanhutext0" v-show="!activeStates3[index]"></span>

                        <div
                                class="hover-mask"
                                :class="{ 'active': activeStates3[index] }"
                                @click.stop="toggleActive(index, 3)"
                        >
                            <div class="hover-content">
                                <div class="problem-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_problem_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.problem.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.problem.value }}</span>
                                    </div>
                                </div>
                                <div class="solution-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper  flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_solve_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.solve.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.solve.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeStates1: [], // 控制 loopData1 的显示状态
                activeStates2: [], // 控制 loopData2 的显示状态
                activeStates3: [], // 控制 loopData3 的显示状态
                loopData1: [
                    {
                        id:101,
                        show:true,
                        lanhutext0: '战略决策盲区',
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve3_icon_01.png'),
                        },
                        problem: {title:'痛点',value:'应对市场变化响应滞后'},
                        solve:{title:'解决方案',value:'行业数据库+竞争对标分析，缩短决策链路，降低试错成本'},
                        slot1: 1
                    },
                    {
                        id:102,
                        show:true,
                        lanhutext0: '跨部门协同低效',
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve3_icon_02.png'),
                        },
                        problem: {title:'痛点',value:'部门目标冲突导致内耗'},
                        solve:{title:'解决方案',value:'建立"风险共担-利益共享"机制，优化组织协作效率'},
                        slot1: 1
                    },
                ],
                loopData2: [
                    {
                        id:103,
                        show:true,
                        lanhutext0: '营销收益率低',
                        slot1: 1,
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve3_icon_03.png'),
                        },
                        problem: {title:'痛点',value:'营销费用虚高、资源错配导致ROI低迷'},
                        solve:{title:'解决方案',value:'全链路诊断优化资源分配，助力优化营销效能提升RO'},
                    },
                    {
                        id:104,
                        show:true,
                        lanhutext0: '数据价值未释放',
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve3_icon_04.png'),
                        },
                        problem: {title:'痛点',value:'海量业务数据沉睡'},
                        solve:{title:'解决方案',value:'AI建模挖掘销售异常、供应链断点等隐患，转化数据为决策资产'},
                        slot1: 1
                    },
                ],
                loopData3: [
                    {
                        id:105,
                        show:true,
                        lanhutext0: '合规转型阵痛',
                        slot1: 1 ,
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve3_icon_05.png'),
                        },
                        problem: {title:'痛点',value:'传统模式难适应新规'},
                        solve:{title:'解决方案',value:'提供"制度重塑+数字化工具+人员培训"三位一体转型解决方案'},
                    },
                    {
                        id:106,
                        show:false,
                        lanhutext0: '合规转型阵痛',
                        slot1: 1 ,
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve3_icon_05.png'),
                        },
                        problem: {title:'痛点',value:'传统模式难适应新规'},
                        solve:{title:'解决方案',value:'提供"制度重塑+数字化工具+人员培训"三位一体转型解决方案'},
                    },
                ],
            };
        },
        methods: {
            handleMouseEnter(index, listType) {
                if (listType === 1) {
                    this.$set(this.activeStates1, index, true);
                } else if (listType === 2) {
                    this.$set(this.activeStates2, index, true);
                } else if (listType === 3) {
                    this.$set(this.activeStates3, index, true);
                }
            },
            // 鼠标离开时，如果之前没有点击过，则恢复初始状态
            handleMouseLeave(index, listType) {
                if (listType === 1 && !this.activeStates1[index]) {
                    this.$set(this.activeStates1, index, false);
                } else if (listType === 2 && !this.activeStates2[index]) {
                    this.$set(this.activeStates2, index, false);
                } else if (listType === 3 && !this.activeStates3[index]) {
                    this.$set(this.activeStates3, index, false);
                }
            },

            toggleActive(index, listType) {
                if (listType === 1) {
                    this.$set(this.activeStates1, index, !this.activeStates1[index]);
                } else if (listType === 2) {
                    this.$set(this.activeStates2, index, !this.activeStates2[index]);
                } else if (listType === 3) {
                    this.$set(this.activeStates3, index, !this.activeStates3[index]);
                }
            }
        }
    };
</script>

<style scoped lang="css">
    .page_hx_core {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .group_10 {
        width: 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_9 {
        background-color: rgba(255, 255, 255, 1);
        width: calc(100% - 20px);
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
    }

    .text_27 {
        width: 100%;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin: 48px 0 0 0;
    }

    .text_28 {
        width: 100%;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 15px;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-bottom: 10px;
    }

    .list_10 {
        width: 100%;
        max-width: 1200px;

        margin: 10px auto 10px;
        display: flex;
        justify-content: center;
        gap: 10px;
    }
    .list_10_one {
        width: 100%;
        max-width: 1200px;
        margin: 10px auto 10px;
        display: flex;
        justify-content: center;
        gap: 10px;
    }

    .list-items_1 {
        border-radius: 10px;
        position: relative;
        width: 50%;
        max-width: 280px;
        height: 225px;
        border: 1px solid rgba(230, 230, 230, 1);
        align-items: center;
        overflow: hidden;
    }
    .list-items_1.hidden-item {
        visibility: hidden;
        opacity: 0;
        height: 0;
        padding: 0;
        border: none;
        margin: 0;
    }


    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .hover-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(229, 242, 242, 1);
        border-radius: 10px;
        opacity: 0;
        transform: translateY(100%);
        transition: all 0.3s linear;
        padding: 20px;
        box-sizing: border-box;
        pointer-events: none;
    }

    .list-items_1 {
        cursor: pointer; /* 添加手型指针，表示可点击 */
    }

    .hover-mask.active {
        opacity: 1;
        transform: translateY(0);
        pointer-events: auto;
    }

    .hover-content {
        color: white;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .problem-section,
    .solution-section {
        display: flex;
        align-items: flex-start;
        gap: 5px;
    }

    .icon-wrapper {
        width: 59px;
        height: 22px;
        margin: 5px 0 0 10px;
    }
    .thumbnail_2 {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-right: 8px;
    }
    .text-group_8 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 106, 112, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
    }
    .text_38 {
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        text-align: left;
        line-height: 25px;
        margin: 2px 0 0 35px;
    }

    .text-wrapper p {
        font-size: 14px;
        line-height: 1.5;
        margin: 0;
        color: #FFFFFF;
    }

    .solution-section .text-wrapper h3 {
        color: #4CAF50;
    }

    .image_10 {
        position: absolute;
        top: 65px;
        width: 50px;
        height: 50px;
    }

    .label_5 {
        position: absolute;
        top: 68px;
        width: 31px;
        height: 44px;
    }

    .text_29 {
        width: 180px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        text-align: center;
        white-space: nowrap;
        line-height: 30px;
        margin: 139px 0 0 0;
    }

    @media (min-width: 621px) {
        .list_10, .list_10_one {
            justify-content: center;
            padding-left: 10px;
        }

        .list-items_1 {
            margin-right: 0;
            margin-left: 0;
        }
    }

    @media (max-width: 620px) {
        .list_10, .list_10_one {
            justify-content: flex-start
        }

        .list-items_1 {
            margin-right: 0;
            margin-left: 0;
        }
    }

    /* 超小屏幕样式 */
    @media (max-width: 480px) {
        .hover-mask {
            padding: 6px;
        }
        .text_38 {
            font-size: 10px;
            text-align: left;
            line-height: 15px;
            margin: 2px 0 0 35px;
        }
        .solution-section {
            margin-top: -5px;
        }
        .list-items_1 {
            height: 140px;
        }
        .image_10 {
            top: 35px;
            width: 40px;
            height: 40px;
        }
        .label_5 {
            top: 35px;
            width: 30px;
            height: 40px;
        }
        .text_29 {
            font-size: 20px;
            margin: 90px 0 0 0;
        }
        .text-group_8 {
            font-size: 15px;
        }
    }
    @media (max-width: 390px) {

        .hover-mask {
            padding: 4px;
        }
        .text_38 {
            font-size: 10px;
            text-align: left;
            line-height: 15px;
            margin: 2px 0 0 35px;
        }
        .solution-section {
            margin-top: -5px;
        }
        .list-items_1 {
            height: 140px;
        }
        .image_10 {
            top: 35px;
            width: 40px;
            height: 40px;
        }
        .label_5 {
            top: 35px;
            width: 30px;
            height: 40px;
        }
        .text_29 {
            font-size: 20px;
            margin: 90px 0 0 0;
        }
        .text-group_8 {
            font-size: 14px;
        }
    }
</style>
